import React, { Component } from 'react';
class PageTitleArea extends Component {
    render() {

        let { pageTitle, pageDescription } = this.props;

        return (
            <div className="mainbanner">
                <div className="page-title-area">
                    <div className="container">
                        <div className="page-title-content">
                            <h1>{pageTitle}</h1>
                            <p>{pageDescription}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PageTitleArea;